<template>
    <section :class="['hero-banner-section', { transparent: transparentHeader }]">
        <div :class="[{ 'small-hero-banner': territory === 'usa' }, 'container']">
            <div class="row">
                <div class="col-12">
                    <h1>{{ $t('heroForm.smartWayHeading') }}</h1>
                </div>

                <div class="col-12">
                    <h2 v-html="$t('heroForm.searchHeading')"></h2>
                </div>
            </div>

            <form class="row form" @submit="submit">
                <div :class="[partnerLogoClasses, 'd-none d-lg-block text-end']">
                    <img
                        class="partner-logo pb-4"
                        :src="asset(`/img/logos/${monevoLogo}`)"
                        alt="Powered by Monevo"
                        width="110"
                        v-if="themeSetting('hide_powered_by_monevo_logo_hero_form') == 0"
                    />
                </div>

                <div :class="'col-12 input-container credit-type col-lg-6'">
                    <SelectField
                        name="cardType"
                        :customErrorMessage="$t('form.fields.cardType.errorMessage')"
                        :label="$t('form.fields.cardType.label')"
                        icon="fas fa-credit-card"
                        :options="cardTypes"
                        :validationRules="{
                            required: true,
                        }"
                        vuexKey="internal"
                    />
                </div>

                <div :class="['col-12 input-container col-lg-3']">
                    <input
                        class="button secondary submit-button"
                        type="submit"
                        :value="$t('heroForm.submit')"
                        @click="submit"
                    />

                    <div class="col-12 disclaimer-text d-none d-lg-inline">
                        <p class="text-center" v-html="$t('heroForm.notAffectCredit')"></p>
                    </div>
                </div>

                <div class="col-12 disclaimer-text d-lg-none">
                    <p class="text-center" v-html="$t('heroForm.notAffectCredit')"></p>
                    <img
                        class="partner-logo"
                        :src="asset(`/img/logos/${monevoLogo}`)"
                        alt="Powered by Monevo"
                        v-if="themeSetting('hide_powered_by_monevo_logo_hero_form') == 0"
                        width="110"
                    />
                </div>
            </form>
        </div>
    </section>
</template>

<script>
import { useForm } from 'vee-validate'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

export default {
    props: ['monevoLogo', 'isHomeownerMaxLoan', 'poorCreditMaxLoan'],
    setup() {
        const router = useRouter()
        const store = useStore()
        const { validate } = useForm()

        return {
            validate,
            router,
            store,
        }
    },
    methods: {
        submit: async function (e) {
            document.activeElement.blur()
            e.preventDefault()

            const validationResult = await this.validate()

            if (!validationResult.valid) {
                return false
            }

            this.router.push({ name: 'apply' })
        },
    },

    computed: {
        cardTypes: function () {
            return this.$i18n.messages[this.$i18n.locale].form.fields.cardType.options
        },

        territory: function () {
            return process.env.TERRITORY
        },

        partnerLogoClasses: function () {
            return 'col-lg-12 col-xl-12'
        },

        transparentHeader: function () {
            return this.themeSetting('transparent_header') === 1
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~scss/settings/responsive';
@import '~scss/mixins/rem';

.hero-banner-section {
    background: linear-gradient(180deg, var(--hero-gradient-color-top), var(--hero-gradient-color-bottom));
    background-position: center;
    background-size: cover;
    padding: 47px 0px;

    .small-hero-banner {
        max-width: 1000px;
    }

    &.transparent {
        margin-top: -75px;
        padding: 107px 0px;
    }

    h1 {
        color: var(--hero-text);
        font-family: var(--heading-font);
        font-size: rem(32px);
        font-weight: bold;
        letter-spacing: -0.01em;
        text-align: center;
    }

    h2 {
        color: var(--hero-text);
        font-family: var(--heading-font);
        font-size: rem(20px);
        font-weight: normal;
        margin-bottom: 32px;
        text-align: center;

        strong {
            color: var(--hero-text);
        }
    }

    @media screen and (min-width: $bp-large) {
        padding: 162px 0px;

        &.transparent {
            margin-top: -96px;
            padding: 258px 0px;
        }

        h1 {
            color: var(--hero-text);
            text-align: left;
        }

        h2 {
            color: var(--hero-text);
            text-align: left;

            strong {
                color: var(--hero-text);
            }
        }
    }
}

.form {
    background: var(--hero-form-background);
    border-radius: 8px;
    box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.32);
    margin: 0 15px;
    padding: 15px;

    @media screen and (min-width: $bp-large) {
        padding: 24px 30px;
        margin: 0px;
    }

    .input-container {
        padding: 0 5px 10px;
    }

    .submit-button {
        border: none;
        border-radius: 4px;
        color: var(--cta-form-button-text-color);
        font-size: 15px;
        font-weight: bold;
        height: 52px;
        text-align: center;
        width: 100%;

        @media screen and (min-width: $bp-large) {
            margin: 0px;
        }
    }

    .partner-logo {
        max-width: 90px;
    }

    .disclaimer-text {
        text-align: center;
        padding: 0 5px;

        p {
            color: var(--hero-form-subtext-color);
            font-family: var(--primary-font);
            font-size: 11px;
            font-style: normal;
            line-height: 13px;
            margin-bottom: 30px;

            @media screen and (min-width: $bp-large) {
                margin-bottom: 0;
                margin-top: 10px;
            }
        }

        img {
            margin-bottom: 20px;
        }

        @media screen and (min-width: $bp-large) {
            text-align: left;
            padding: 0;
        }
    }
}
</style>

<style lang="scss">
@import '~scss/settings/responsive';

@media screen and (min-width: $bp-large) {
    .hero-banner-section {
        .input-container {
            .error {
                position: absolute;
            }
        }
    }
    .credit-type {
        margin-left: 7rem;
    }
}

@media screen and (min-width: $bp-xl) {
    .credit-type {
        margin-left: 7rem;
    }
}
</style>
